<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <v-icon>
        mdi-card-text-outline
      </v-icon>
      Self-Schedule Invites
    </SecondaryButton>
    <SelfScheduleInviteListDialog
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import SelfScheduleInviteListDialog from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/SelfScheduleInviteListDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "ViewSelfScheduleInvitesAction",
  components: {
    SelfScheduleInviteListDialog,
    SecondaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
